module.exports = __webpack_public_path__ + "static/marketing-306e84dcc628997d77118dc29f6bc8fd.png";